module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAISE FOR")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOK")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE OF THE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRROR")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISITOR")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UARTET")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“This book is bursting with inventiveness.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Monde des livres")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Winter’s Promise ")]), _vm._v("is an elaborate hall of mirrors, a hallucinatory marriage of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pride and Prejudice")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Game of Thrones")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATTHEW ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KELTON")]), _vm._v(", author of the Endymion Spring books ")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“As mesmerizing as a waking dream, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Winter’s Promise")]), _vm._v(" is certain to ensnare you in its unique, dizzyingly magical world of treachery, illusion, and intrigue.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARGARET ")]), _vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OGERSON")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Bestselling author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Enchantment of Ravens")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mirror Visitor ")]), _vm._v("now stands on the same shelf as Harry Potter.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elle")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Immersive . . . Holds as much appeal for adult fantasy readers as for teens.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“A captivating fantasy thriller rife with magic and intrigue.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword Reviews")]), _vm._v(" (Starred Review)")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“The world Dabos has created with painstaking detail, which features a version of our planet that’s been split up into separate Arks with different climates and societies, is crying out to be brought to life onscreen.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BookRiot")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Ophelia is stronger than she looks . . . She’s the tiny-voiced powerhouse you can’t take your eyes off, the any-of-us among more powerful sorts who wish to use her for their gain.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN ")]), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLL")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“As gripping as it is beautifully imaginative . . . Daring and spectacular, this is a novel to read under the covers, in spare time, whenever the chance arises; readers will not soon forget "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mirror Visitor")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Teen Reads")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“I loved "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Winter’s Promise")]), _vm._v(", which felt simultaneously fresh and also like a classic along the lines of Narnia.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geekly Inc")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Dabos draws her fantasy world and cast of characters in life-like, vivid detail . . . Ophelia is able to grow as a character without betraying her values. I would absolutely recommend this book to readers who enjoy well-built fantasy worlds and family and political dramas.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children’s Book World’s Teen Readers Council")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“The unusual settings, original characters, dark intrigue, originality, and fast-moving plot result in a book that leaves readers eagerly awaiting the next volume.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("School Library Journal")]), _vm._v(" (Starred Review) ")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Dabos’s darkly enchanting debut, a French bestseller, employs vibrant characters, inventive worldbuilding, and a sophisticated plot that will dazzle readers.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")]), _vm._v(" (Starred Review)")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Your next YA obsession . . . An irresistible mix of character development, imaginative world-building, and tightly-wound suspense.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Entertainment Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Dabos has managed the rarely seen triad of complex worldbuilding, nuanced character development, and enthralling plot, even making it look easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“I was too engrossed to interrupt myself with thoughts on how I was going to review it.  I was under the spell of a master-story teller, a spell only the turning of the final page would break.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IZZY ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDDAL,")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("blogger")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b9f820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EE_DABOS_CLAIRDELUNE_ebk_00001.vue
// module id = 63
// module chunks = 0